<template>
  <v-banner single-line color="info" dark>
    <v-tooltip bottom v-if="text.length > 40">
      <template v-slot:activator="{ on }">
        <span v-on="on" v-text="text"></span>
      </template>
      <span v-text="text"></span>
    </v-tooltip>
    <span v-text="text" v-else></span>
    <template v-slot:actions="{ dismiss }">
      <v-btn icon @click="openDialog" v-if="$store.state.editable" x-small><v-icon>mdi-pencil</v-icon></v-btn>
        <v-dialog v-model="dialog" max-width="400">
          <v-card :loading="loading">
            <v-card-title>
              배너 수정
              <v-spacer/>
              <v-btn @click="save" color="primary" text>
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
              <v-btn icon text @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="setText"
                outlined
                label="내용"
                hide-details
                @keypress.enter="save"
                ></v-text-field>
            </v-card-text>
          </v-card>
        </v-dialog>
      <v-btn text @click="dismiss" icon small><v-icon small>mdi-close</v-icon></v-btn>
    </template>
  </v-banner>
</template>
<script>
export default {
  props: ['text'],
  data () {
    return {
      loading: false,
      dialog: false,
      setText: ''
    }
  },
  methods: {
    openDialog () {
      this.dialog = true
      this.setText = this.text
    },
    async save () {
      try {
        this.loading = true
        const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : 'default'
        await this.$firebase.database().ref().child('sites').child(uid).update({
          banner: this.setText
        })
      } finally {
        this.dialog = false
        this.loading = false
      }
    }
  }
}
</script>
